export default __webpack_public_path__ + "static/media/japangot-screenshot-02.21132564.png";